import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Tag as TagComponent } from '@design-system/components/tag/tag';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import _ from 'lodash';
import { useState } from 'react';
import { TagValidation, maxTagsLimit } from '../view-models/mappers';
import { EditWorkoutVM } from '../view-models/workoutEdit.viewModel';
import { Tag } from 'generated/graphql';
import { clsx } from 'clsx';

export const Tags = ({
  options,
  tags,
  onChange,
  disabled,
}: {
  options: EditWorkoutVM['tagOptions'];
  tags: Tag[];
  onChange: (values: Tag[]) => void;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col justify-between">
      <div className="flex justify-between">
        <Typography>Tags</Typography>
        {_.isEmpty(tags) ? (
          <Button
            color="primaryTonal"
            onClick={() => setOpen(true)}
            testId="addTag"
            disabled={disabled}
          >
            Add
          </Button>
        ) : (
          <Button
            variant="text"
            color="primary"
            onClick={() => setOpen(true)}
            testId="editTag"
            disabled={disabled}
          >
            Edit
          </Button>
        )}
      </div>
      {!_.isEmpty(tags) ? null : (
        <Typography variant="body" className={sprinkles({ color: 'N-80' })}>
          Tags informs users briefly about workout
        </Typography>
      )}
      <div className="flex flex-wrap gap-2">
        {tags.map((t) => (
          <TagComponent key={t.id} label={t?.title || ''} />
        ))}
      </div>
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="Add tags"
        description={
          _.isEmpty(tags)
            ? 'Select max.10'
            : `Selected ${tags.length} out of ${maxTagsLimit}`
        }
      >
        <div
          className={clsx(
            sprinkles({
              display: 'flex',
              flexDirection: 'column',
              gap: 'xl',
            }),
            'max-h-[500px] md:max-h-full',
          )}
        >
          {options.map((option) => (
            <CategoryContent
              key={option.category}
              {...option}
              selected={tags}
              select={onChange}
            />
          ))}
        </div>
      </Modal>
    </div>
  );
};

const CategoryContent = ({
  category,
  values,
  selected,
  max,
  validation,
  select,
  description,
}: {
  category: string;
  values: Array<Tag>;
  selected: Tag[];
  max?: number;
  validation: TagValidation;
  description: string;
  select: (v: Tag[]) => void;
}) => (
  <div className="flex flex-col gap-2">
    <div className="flex justify-between items-center">
      <Typography variant="bodyLarge">{category}</Typography>
      <Typography>{description}</Typography>
    </div>
    <div className="flex flex-wrap gap-2">
      {values.map((v) => {
        const tagSelected = !!_.find(selected, ['id', v.id]);
        const disabled =
          !tagSelected &&
          (selected.length === maxTagsLimit ||
            (values && values.length === max));
        return (
          <TagComponent
            key={v.id}
            label={v?.title || ''}
            selected={tagSelected}
            onClick={() => select(validation(selected, v))}
            disabled={disabled}
          />
        );
      })}
    </div>
  </div>
);
